// Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import { mapValues } from 'lodash'

import {
  KeyValueTable,
  SvgIcon,
  Spinner,
  SpanWithData,
  ExpandableSection,
  TriggerableActionItem as ActionItem
} from '../'

const QUERY_IDENTITY_WHATSAPP = gql`
  query($id: ID!) {
    identity(id: $id) {
      id
      isWhatsappable
      waId
      whatsappsession {
        id
        mode
        activeRequestrun {
          id
          requesttype {
            id
            name
          }
        }
      }
    }
  }
`


export class IdentityWhatsAppSession extends React.Component {
  static propTypes = {
    identityId: PropTypes.string.isRequired,
    title: PropTypes.string,
    className: PropTypes.string
  }

  static defaultProps = {
    title: 'WhatsApp session',
    className: ''
  }

  state = {
    expanded: true
  }

  toggleExpand = () => this.setState(prevState => ({ expanded: !prevState.expanded }))

  render() {
    const { identityId, title, className } = this.props

    return (
      <Query query={QUERY_IDENTITY_WHATSAPP} variables={{ id: identityId }}>
        {({ loading, error, data }) => {
          let sessionInfo = {
            id: <Spinner size='xx-small' />,
            mode: <Spinner size='xx-small' />,
            'active request': <Spinner size='xx-small' />,
            whatsappable: <Spinner size='xx-small' />
          }

          if (error) {
            sessionInfo = mapValues(sessionInfo, () => (
              <SvgIcon
                variant='utility'
                symbol='warning'
                colour='error'
                size='xx-small'
              />
            ))
          }

          if (data.identity && data.identity.whatsappsession) {
            const identity = data.identity
            sessionInfo.id = identity.waId
            sessionInfo.mode = <SpanWithData forField='WhatsappSessionMode' searchKey={identity.whatsappsession.mode} />
            sessionInfo['active request'] = identity.whatsappsession.activeRequestrun
              ? identity.whatsappsession.activeRequestrun.requesttype.name
              : 'None'
            sessionInfo.whatsappable = identity.isWhatsappable
              ? 'Yes'
              : 'No'
          }

          if (loading === false && data.identity.whatsappsession === null) {
            return (
              <div className='slds-p-top_small'>
                <SvgIcon
                  variant='utility'
                  symbol='info'
                  colour='light'
                  size='small'
                  className='slds-p-right_x-small slds-p-left_medium'
                />
                Identity has no WhatsApp session.
              </div>
            )
          }

          return (
            <ExpandableSection
              open={this.state.expanded}
              title={title}
              summary={
                <div className='slds-grid slds-text-color_weak whatsapp-session-info-summary'>
                  <div>ID: {sessionInfo.id}</div>
                  <div>MODE: {sessionInfo.mode}</div>
                  <div>ACTIVE REQUEST: {sessionInfo['active request']}</div>
                  <div>WHATSAPP-ABLE: {sessionInfo.whatsappable}</div>
                </div>
              }
              onClick={this.toggleExpand}
              expandIconOnLeft={true}
              className={className}
              style={{ margin: 0 }}>
              <div className='slds-grid'>
                <KeyValueTable
                  data={sessionInfo}
                  keyColumnSize="1-of-2"
                  className='slds-col slds-size_1-of-2 slds-m-bottom_x-large'
                />
                <div className='slds-col slds-size_1-of-2'>
                  <div className='slds-size_3-of-4 slds-m-left_x-large'>
                    <div className='u-font-size-larger slds-m-bottom_medium'>
                      <b>Actions</b>
                    </div>
                    <React.Fragment>
                      <ActionItem
                        name='Block'
                        triggerLabel='block'
                        triggerOnClick={() => null}
                        component={null}
                        disabled={true}
                        className='slds-m-bottom_small'
                      />
                      <ActionItem
                        name='View open requests'
                        triggerLabel='view'
                        triggerOnClick={() => null}
                        disabled={true}
                        className='slds-m-bottom_small'
                      />
                      <ActionItem
                        name='Cancel open request'
                        triggerLabel='cancel'
                        triggerOnClick={() => null}
                        disabled={true}
                        className='slds-m-bottom_small'
                      />
                    </React.Fragment>
                  </div>
                </div>
              </div>
            </ExpandableSection>
          )
        }}
      </Query>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/identity-whatsapp-session/index.js